module.exports = __webpack_public_path__ + "img/07.d8ff8f9d.jpg";